var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isElegible
        ? _c(
            "div",
            {
              staticClass:
                "fit-content rounded-pill py-2 pl-2 pr-3 text-nowrap text-white bg-green font-weight-bold"
            },
            [
              _c("i", { staticClass: "fas fa-check-circle mx-1" }),
              _c("span", { staticClass: "ml-1" }, [_vm._v("Elegible")])
            ]
          )
        : [
            _c(
              "div",
              {
                staticClass:
                  "fit-content d-inline-block rounded-pill py-2 pl-2 pr-3 text-nowrap text-white mr-2 font-weight-bold",
                class: [_vm.hasConsent ? "bg-green" : "bg-red"]
              },
              [
                _c("i", { staticClass: "fas fa-signature mx-1" }),
                !_vm.hasConsent
                  ? _c("span", { staticClass: "ml-1" }, [_vm._v("Falta")])
                  : _vm._e(),
                _c("span", { staticClass: "ml-1" }, [_vm._v("Consentimiento")])
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "fit-content d-inline-block rounded-pill py-2 pl-2 pr-3 text-nowrap text-white font-weight-bold",
                class: [_vm.hasMedicalPlan ? "bg-green" : "bg-red"]
              },
              [
                _c("i", { staticClass: "fas fa-briefcase-medical mx-1" }),
                !_vm.hasMedicalPlan
                  ? _c("span", { staticClass: "ml-1" }, [_vm._v("Falta")])
                  : _vm._e(),
                _c("span", { staticClass: "ml-1" }, [_vm._v("Plan Médico")])
              ]
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }